import React from "react";
import { ArrowLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#F8FDFF]">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0C3547] to-[#155E75] py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-cyan-300 hover:text-white transition-colors mb-8 text-sm" data-testid="privacy-back-link">
            <ArrowLeft size={18} />
            Vissza a főoldalra
          </Link>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Adatvédelmi Tájékoztató
          </h1>
          <p className="text-cyan-200 mt-4 text-sm md:text-base">Hatályos: 2026. 04. 15. – től visszavonásig, vagy módosításig</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 md:py-16">
        <div className="prose-policy">

          {/* TOC */}
          <div className="policy-toc">
            <h3>Tartalom</h3>
            <ol>
              <li><a href="#s1">Adatkezelő adatai</a></li>
              <li><a href="#s2">Adatvédelmi nyilatkozat</a></li>
              <li><a href="#s3">Fogalmak</a></li>
              <li><a href="#s4">Az adatkezelés alapvető elvei</a></li>
              <li><a href="#s5">Kezelt adatok</a></li>
              <li><a href="#s6">Az adatok biztonsága</a></li>
              <li><a href="#s7">Az adatok továbbítása, átadása</a></li>
              <li><a href="#s8">Érintettek jogai</a></li>
            </ol>
          </div>

          {/* 1 */}
          <h2 id="s1">1. Adatkezelő adatai</h2>
          <div className="policy-info-card">
            <div className="policy-info-row"><span>Megnevezés:</span><strong>BÁZA-BAU Kft.</strong></div>
            <div className="policy-info-row"><span>Székhely:</span><strong>8200 Veszprém, Tizenháromváros tér 1155 hrsz.</strong></div>
            <div className="policy-info-row"><span>Adószám:</span><strong>29029367-2-19</strong></div>
            <div className="policy-info-row"><span>Cégjegyzékszám:</span><strong>19 09 525415</strong></div>
            <div className="policy-info-row"><span>Telefon:</span><strong>+36 70 260 2689</strong></div>
            <div className="policy-info-row"><span>Email:</span><strong>baza.bau.kft@gmail.com</strong></div>
          </div>

          {/* 2 */}
          <h2 id="s2">2. Adatvédelmi nyilatkozat</h2>
          <p>
            Ez az Adatvédelmi tájékoztató és nyilatkozat (a továbbiakban: Tájékoztató) a BÁZA-BAU Kft. (továbbiakban: Adatkezelő) tevékenységére vonatkozóan tartalmazza az adatvédelemmel kapcsolatos információkat. Szolgáltatásunk igénybevétele során Ön megadja személyes adatait. Ezeket az adatokat a legnagyobb körültekintéssel, a jogszabályok előírásainak megfelelően kezeljük, és minden esetben igyekszünk az Ön adatkezeléssel kapcsolatos igényeinek és elvárásainak megfelelni. Az adatok kezelése során mindig különös gondossággal járunk el, és az adatokat védjük az illetéktelen hozzáféréstől.
          </p>

          <p>Az adatkezelési tevékenységünket meghatározó jogszabályok:</p>
          <ul>
            <li>Az Európai Parlament és a Tanács (EU) 2016/679 rendelete (GDPR)</li>
            <li>Az információs önrendelkezési jogról szóló 2011. évi CXII. törvény (Infotv.)</li>
            <li>Magyarország Alaptörvénye</li>
            <li>A Polgári törvénykönyvről szóló 2013. évi V. törvény (Ptk.)</li>
            <li>2003. évi C. törvény az elektronikus hírközlésről (Eht.)</li>
            <li>2001. évi CVIII. törvény (Eker tv.)</li>
            <li>2017. évi CL. törvény (Art.)</li>
            <li>2000. évi C. törvény (Sztv. tv.)</li>
            <li>1997. évi CLV. törvény (Fogyv tv.)</li>
            <li>2008. évi XLVIII. törvény (Grtv.)</li>
          </ul>

          {/* 3 */}
          <h2 id="s3">3. Fogalmak</h2>
          <div className="policy-definitions">
            <div className="policy-def">
              <strong>GDPR:</strong> Az Európai Parlament és a Tanács (EU) 2016/679 Rendelete a természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről.
            </div>
            <div className="policy-def">
              <strong>Személyes adat:</strong> az érintettre vonatkozó bármely információ, például név, szám, helymeghatározó adat, online azonosító vagy a természetes személy azonosságára vonatkozó adat.
            </div>
            <div className="policy-def">
              <strong>Adatkezelés:</strong> a személyes adatokon végzett bármely művelet, így különösen gyűjtése, rögzítése, rendszerezése, tárolása, megváltoztatása, felhasználása, továbbítása, törlése és megsemmisítése.
            </div>
            <div className="policy-def">
              <strong>Adatkezelő:</strong> az a személy vagy szervezet, aki a személyes adatok kezelésének célját és eszközeit meghatározza.
            </div>
            <div className="policy-def">
              <strong>Adatfeldolgozó:</strong> az a személy vagy szervezet, aki az adatkezelő nevében személyes adatokat kezel.
            </div>
            <div className="policy-def">
              <strong>Érintett:</strong> bármely azonosított vagy azonosítható természetes személy.
            </div>
            <div className="policy-def">
              <strong>Adatvédelmi incidens:</strong> a biztonság olyan sérülése, amely a személyes adatok véletlen vagy jogellenes megsemmisítését, elvesztését, megváltoztatását, jogosulatlan közlését vagy hozzáférést eredményezi.
            </div>
            <div className="policy-def">
              <strong>NAIH:</strong> Nemzeti Adatvédelmi és Információszabadság Hatóság, a GDPR szerinti magyar felügyeleti hatóság.
            </div>
          </div>

          {/* 4 */}
          <h2 id="s4">4. Az adatkezelés alapvető elvei</h2>
          <p>A személyes adatok:</p>
          <ul>
            <li>kezelését jogszerűen és tisztességesen, átlátható módon végezzük (<em>„jogszerűség, tisztességes eljárás és átláthatóság"</em>)</li>
            <li>gyűjtése csak meghatározott, egyértelmű és jogszerű célból történhet (<em>„célhoz kötöttség"</em>)</li>
            <li>az adatkezelés céljai szempontjából megfelelőek és relevánsak kell, hogy legyenek (<em>„adattakarékosság"</em>)</li>
            <li>pontosak és naprakészek kell, hogy legyenek (<em>„pontosság"</em>)</li>
            <li>tárolása a szükséges ideig történhet (<em>„korlátozott tárolhatóság"</em>)</li>
            <li>megfelelő biztonság biztosítva van (<em>„integritás és bizalmas jelleg"</em>)</li>
          </ul>

          {/* 5 */}
          <h2 id="s5">5. Kezelt adatok</h2>
          <h3>5.1 Szolgáltatás megrendelése és időpontfoglalás (kérdőív kitöltéssel)</h3>
          <p>
            <strong>Érintettek:</strong> Azok a természetes/jogi személyek, akik a szolgáltatást megrendelik és időpontot foglalnak.<br />
            <strong>Adatkezelés célja:</strong> Kapcsolattartás, a megrendelés teljesítése.
          </p>
          <div className="policy-table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Adatfajta</th>
                  <th>Jogalap</th>
                  <th>Őrzési idő</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Név</td><td rowSpan="5">GDPR 6. cikk a) pont (hozzájárulás)</td><td rowSpan="5">Hozzájárulás visszavonásáig</td></tr>
                <tr><td>E-mail cím</td></tr>
                <tr><td>Telefonszám</td></tr>
                <tr><td>Lakcím</td></tr>
                <tr><td>Időpont</td></tr>
              </tbody>
            </table>
          </div>
          <p>
            A fenti adatok megadása nem kötelező, ezek hiányában azonban nem tudunk kapcsolatot tartani Önnel és nem tudjuk a megrendelését teljesíteni. A hozzájárulását bármikor indokolás nélkül visszavonhatja.
          </p>

          {/* 6 */}
          <h2 id="s6">6. Az adatok biztonsága</h2>
          <p>
            Technikai és szervezési intézkedésekkel gondoskodunk az általunk kezelt személyes adatok biztonságáról. Az adatokat megfelelő intézkedésekkel védjük a jogosulatlan hozzáférés, megváltoztatás, továbbítás, nyilvánosságra hozatal, törlés vagy megsemmisítés ellen.
          </p>
          <ul>
            <li>Az informatikai rendszer tervezése során felmérjük a kockázatokat</li>
            <li>Figyelemmel kísérjük a fenyegetéseket és sérülékenységeket</li>
            <li>Védjük az eszközöket az illetéktelen fizikai hozzáférés és környezeti hatások ellen</li>
            <li>Az üzemeltetésben résztvevő szolgáltatók kiválasztásánál a megbízhatóság az alapvető szempont</li>
          </ul>

          {/* 7 */}
          <h2 id="s7">7. Az adatok továbbítása, átadása</h2>
          <p>
            A személyes adatokat kizárólag a partnereinknek, adatfeldolgozóinknak továbbítjuk, valamint a hatóságoknak megkeresés esetén. Partnereinkkel minden esetben az adatkezelés részleteire kiterjedő írásbeli megállapodást kötöttünk.
          </p>

          {/* 8 */}
          <h2 id="s8">8. Az érintettek jogai</h2>

          <h3>8.1 Előzetes tájékoztatáshoz való jog</h3>
          <p>Az érintett jogosult arra, hogy a személyes adatokra vonatkozó adatkezelés megkezdése előtt átláthatóan, érthetően és könnyen hozzáférhetően írásban tájékoztatást kapjon az Adatkezelőtől.</p>

          <h3>8.2 A hozzáférés joga</h3>
          <p>Az érintett jogosult arra, hogy visszajelzést kapjon arról, hogy személyes adatainak kezelése folyamatban van-e, és hozzáférést kapjon az adatkezelés céljairól, az adatok kategóriáiról, a címzettekről, a tárolási időtartamról és a jogairól.</p>

          <h3>8.3 A helyesbítéshez való jog</h3>
          <p>Az érintett jogosult arra, hogy kérésére az Adatkezelő indokolatlan késedelem nélkül helyesbítse a rá vonatkozó pontatlan személyes adatokat.</p>

          <h3>8.4 A törléshez való jog („az elfeledtetéshez való jog")</h3>
          <p>Az érintett jogosult arra, hogy kérésére az Adatkezelő indokolatlan késedelem nélkül törölje a személyes adatokat, ha azokra már nincs szükség, a hozzájárulás visszavonásra került, az érintett tiltakozik, vagy az adatkezelés jogellenes volt.</p>

          <h3>8.5 Az adatkezelés korlátozásához való jog</h3>
          <p>Az érintett jogosult arra, hogy kérésére az Adatkezelő korlátozza az adatkezelést, ha az adatok pontosságát vitatja, az adatkezelés jogellenes, vagy az adatokra jogi igények érvényesítéséhez van szükség.</p>

          <h3>8.6 Értesítéshez való jog</h3>
          <p>Az Adatkezelő köteles a személyes adatok helyesbítéséről, törléséről vagy korlátozásáról valamennyi címzettet tájékoztatni.</p>

          <h3>8.7 Adathordozhatósághoz való jog</h3>
          <p>Az érintett jogosult a rá vonatkozó adatokat tagolt, géppel olvasható formátumban megkapni, és más adatkezelőnek továbbítani.</p>

          <h3>8.8 A tiltakozáshoz való jog</h3>
          <p>Az érintett jogosult a személyes adatai kezelése ellen tiltakozni, különösen közvetlen üzletszerzés esetén.</p>

          <h3>8.9 Automatizált döntéshozatal, profilalkotás</h3>
          <p>Az érintett jogosult arra, hogy ne terjedjen ki rá kizárólag automatizált adatkezelésen alapuló, joghatással járó döntés.</p>

          <h3>8.10 Tájékoztatás adatvédelmi incidensekről</h3>
          <p>Az érintettnek joga van tájékoztatást kapni az őt érintő adatvédelmi incidensekről, amennyiben azok magas kockázattal járnak.</p>

          <h3>8.11 Panasztétel a felügyeleti hatóságnál</h3>
          <p>Az érintett jogosult panaszt tenni a felügyeleti hatóságnál.</p>
          <div className="policy-info-card">
            <div className="policy-info-row"><span>Hatóság:</span><strong>Nemzeti Adatvédelmi és Információszabadság Hatóság (NAIH)</strong></div>
            <div className="policy-info-row"><span>Postacím:</span><strong>1363 Budapest, Pf. 9.</strong></div>
            <div className="policy-info-row"><span>Székhely:</span><strong>1055 Budapest, Falk Miksa utca 9-11.</strong></div>
            <div className="policy-info-row"><span>Honlap:</span><strong><a href="https://www.naih.hu" target="_blank" rel="noopener noreferrer">www.naih.hu</a></strong></div>
            <div className="policy-info-row"><span>Telefon:</span><strong>06-1-391-1400</strong></div>
            <div className="policy-info-row"><span>E-mail:</span><strong>ugyfelszolgalat@naih.hu</strong></div>
          </div>

          <h3>8.12 Bírósági jogorvoslat</h3>
          <p>Minden érintett jogosult hatékony bírósági jogorvoslatra a felügyeleti hatóság döntésével szemben.</p>

          {/* Kapcsolat */}
          <div className="policy-footer-note">
            <h3>Elérhetőségek a joggyakorlás érdekében</h3>
            <ul>
              <li><strong>E-mailben:</strong> baza.bau.kft@gmail.com</li>
              <li><strong>Telefonon:</strong> +36 70 260 2689</li>
            </ul>
            <p className="text-sm text-gray-500 mt-3">Telefonon személyes adatokkal kapcsolatos információkat nem áll módunkban kiadni, mivel nem tudjuk azonosítani a hívó felet.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
